import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'items-left align-center flex h-full w-full flex-col justify-center',
    wrapper: 'mx-auto md:max-w-[460px]',
    title: 'heading-3xl max-md:heading-2xl mb-3 font-[450]',
    description: 'heading-m max-md:heading-s max-md:pr-3',
    buttons: 'mt-8 flex gap-3 max-sm:flex-col',
    button: 'group max-sm:w-full sm:flex-1',
    wishlistButtonContent: 'flex gap-2.5',
    icon: 'size-6 group-hover:[&>path]:stroke-white',
    closeClearModal: '!max-md:hidden'
  }
});
